import React, { useContext, useState } from "react";
import ModalTags from "./ModalTags";
import { IconPicker } from "react-fa-icon-picker";
import {
    Form,
    ColorPicker,
    Input,
    Badge,
    Select,
    Button,
    message,
    Upload,
} from "antd";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { context } from "../../context/context";

import { toast } from "react-toastify";
import ImgCrop from "antd-img-crop";
import { UploadOutlined } from "@ant-design/icons";

const GeoForm = ({ ostan, shahrestan, shahr, setIsModalOpen }) => {
    const [form] = Form.useForm();
    // state
    const [icon, setIcon] = useState("FaArtstation");
    const [coverPic, setCoverPic] = useState("");
    const [isCitySelected, setIsCitySelected] = useState();

    const {
        setForceUpdate,
        ostanColor,
        ostanId,
        ostanName,
        ostanIcon,
        setOstanName,
        setShahrestan,
        setOstanColor,
        setOstanIcon,
        isEditShow,
        parentOstanId,
        shahrestanName,
        countryId,
        shahrestanIcon,
        setShahrestanName,
        setShahrestanIcon,
        setOstan,
        shahrestanColor,
        setShahrestanColor,
        cityColor,
        cityIcon,
        cityName,
        setCityName,
        cityTag,
        cityId,
        setCityColor,
        setCityIcon,
        setCity,
        fileList,
        setFileList,
    } = useContext(context);
    const { Option } = Select;
    const onFinish = () => {
        const name = form.getFieldValue("عنوان");
        const color = document.querySelector(
            ".ant-color-picker-trigger-text"
        ).innerText;

        setIsModalOpen(false);

        if (!isEditShow && ostan) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/addProvince`, {
                province: name,
                color: color,
                icon: icon,
            })
                .then((res) => {
                    setForceUpdate(7);
                    toast.success("استان با موفقیت ساخته شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    console.log(err);
                });
        } else if (!isEditShow && shahrestan) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/addCountry`, {
                provinceId: parentOstanId,
                countryName: name,
                coverPic: coverPic,
                color: color,
                icon: icon,
            })
                .then((res) => {
                    setOstan(true);
                    setShahrestan(false);
                    setForceUpdate(6);
                    toast.success("شهرستان با موفقیت ساخته شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (ostan && isEditShow) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/editprovince`, {
                provinceId: ostanId,
                name: ostanName,
                color: color,
                icon: ostanIcon,
            })
                .then((res) => {
                    setForceUpdate(10);
                    toast.success("استان با موفقیت ویرایش شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (shahrestan && isEditShow) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/editcountry`, {
                provinceId: parentOstanId,
                countryId: countryId,
                name: shahrestanName,
                coverPic: coverPic,
                color: color,
                icon: shahrestanIcon,
            })
                .then((res) => {
                    console.log(res.data);
                    setOstan(true);
                    setShahrestan(false);
                    setForceUpdate(6);
                    toast.success("شهرستان با موفقیت ویرایش شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (shahr && isEditShow && isCitySelected) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/editCity`, {
                provinceId: parentOstanId,
                cityId: cityId,
                name: cityName,
                coverPic: coverPic,
                color: color,
                icon: cityIcon,
                tag: cityTag,
            })
                .then((res) => {
                    setOstan(true);
                    setShahrestan(false);
                    setForceUpdate(6);
                    toast.success("شهر با موفقیت ویرایش شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (shahr && !isEditShow && isCitySelected) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/addCity`, {
                provinceId: parentOstanId,
                countryId: countryId,
                name: cityName,
                color: color,
                icon: cityIcon,
                coverPic: coverPic,
                tag: cityTag,
            })
                .then((res) => {
                    setOstan(true);
                    setCity(false);
                    setForceUpdate(7);
                    toast.success("شهر با موفقیت ساخته شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (shahr && !isEditShow && !isCitySelected) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/addVillage`, {
                provinceId: parentOstanId,
                countryId: countryId,
                name: cityName,
                color: color,
                icon: cityIcon,
                coverPic: coverPic,
                tag: cityTag,
            })
                .then((res) => {
                    setOstan(true);
                    setCity(false);
                    setForceUpdate(7);
                    toast.success("روستا با موفقیت ساخته شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (shahr && isEditShow && !isCitySelected) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/editVillage`, {
                provinceId: parentOstanId,
                villageId: cityId,
                name: cityName,
                color: color,
                icon: cityIcon,
                coverPic: coverPic,
                tag: cityTag,
            })
                .then((res) => {
                    setOstan(true);
                    setCity(false);
                    setForceUpdate(7);
                    toast.success("روستا با موفقیت ویرایش شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        }
    };

    const handleSelect = (value) => {
        value === "city" ? setIsCitySelected(true) : setIsCitySelected(false);
    };
    const handleColorChange = (color) => {
        if (ostan) {
            setOstanColor(color);
        } else if (shahrestan) {
            setShahrestanColor(color);
        } else if (shahr) {
            setCityColor(color);
        }
    };
    const handleInputChange = (e) => {
        if (ostan) {
            setOstanName(e.target.value);
        } else if (shahrestan) {
            setShahrestanName(e.target.value);
        } else if (shahr) {
            setCityName(e.target.value);
        }
    };
    const handleIconChange = (e) => {
        if (ostan) {
            setOstanIcon(e);
        } else if (shahrestan) {
            setShahrestanIcon(e);
        } else if (shahr) {
            setCityIcon(e);
        }
        setIcon(e);
    };
    const props = {
        name: "objectKey",
        action: `${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=658a87ae96f6a0a56ce4707b`,
        headers: {
            authorization: "authorization-text",
        },
        onChange(info) {
            setFileList(info.fileList);
            if (info.file.status === "done") {
                message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
                setCoverPic(info.file.response.files[0]._id);
            } else if (info.file.status === "error") {
                message.error(` در آپلود فایل خطایی رخ داد!`);
            }
        },
    };

    return (
        <>
            <Form form={form} name="control-hooks" onFinish={onFinish}>
                {shahr ? (
                    <Form.Item name="شهر یا روستا">
                        <div style={{ marginTop: "15px" }}>
                            <Badge.Ribbon
                                placement="start"
                                text="شهر یا روستا"
                                style={{ marginTop: "-25px" }}
                            >
                                <Select
                                    defaultValue={"city"}
                                    onChange={handleSelect}
                                >
                                    <Option value="city">شهر</Option>
                                    <Option value="village">روستا</Option>
                                </Select>
                            </Badge.Ribbon>
                        </div>
                    </Form.Item>
                ) : null}

                <Form.Item
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                    name="عنوان"
                >
                    <div className="nameInput">
                        <Badge.Ribbon placement="start" text="عنوان">
                            <Input
                                value={
                                    ostan
                                        ? ostanName
                                        : shahrestan
                                        ? shahrestanName
                                        : shahr
                                        ? cityName
                                        : null
                                }
                                onChange={handleInputChange}
                                style={{
                                    paddingRight: "45px",
                                    marginTop: "15px",
                                }}
                                placeholder="عنوان را وارد کنید"
                            />
                        </Badge.Ribbon>
                    </div>
                </Form.Item>

                {shahr ? (
                    <Form.Item name="تگ">
                        <div>
                            <Badge.Ribbon placement="start" text="تگ(ها)">
                                <ModalTags section="geo" />
                            </Badge.Ribbon>
                        </div>
                    </Form.Item>
                ) : null}
                <div>
                    <Form.Item name="آیکون">
                        <Badge.Ribbon placement="start" text="آیکون">
                            <IconPicker
                                buttonStyles={{
                                    padding: "5px 65px 0 20px",
                                    border: "1px solid silver",
                                    width: "100%",
                                }}
                                value={
                                    ostan
                                        ? ostanIcon
                                        : shahrestan
                                        ? shahrestanIcon
                                        : shahr
                                        ? cityIcon
                                        : null
                                }
                                onChange={(e) => handleIconChange(e)}
                            />
                        </Badge.Ribbon>
                    </Form.Item>
                    <Form.Item name="رنگ">
                        <Badge.Ribbon placement="start" text="انتخاب رنگ">
                            <ColorPicker
                                value={
                                    ostan
                                        ? ostanColor
                                        : shahrestan
                                        ? shahrestanColor
                                        : shahr
                                        ? cityColor
                                        : null
                                }
                                onChange={handleColorChange}
                                style={{
                                    padding: "20px 85px 20px 10px",
                                    width: "100%",
                                }}
                                showText
                            />
                        </Badge.Ribbon>
                    </Form.Item>
                </div>
                {shahrestan || shahr ? (
                    <Form.Item
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="عکس"
                    >
                        <div>
                            <Badge.Ribbon placement="start" text="انتخاب عکس">
                                <ImgCrop rotationSlider modalTitle="ویرایش عکس">
                                    <Upload
                                        fileList={fileList}
                                        maxCount={1}
                                        multiple={false}
                                        {...props}
                                    >
                                        <Button
                                            icon={<UploadOutlined />}
                                            style={{
                                                paddingRight: "6rem",
                                            }}
                                        >
                                            آپلود فایل
                                        </Button>
                                    </Upload>
                                </ImgCrop>
                            </Badge.Ribbon>
                        </div>
                    </Form.Item>
                ) : null}
                <Form.Item>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {isEditShow === true ? (
                            <Button
                                disabled={
                                    (shahrestan && shahrestanName === "") ||
                                    (shahr && cityName === "")
                                }
                                type="primary"
                                htmlType="submit"
                            >
                                ثبت ویرایش
                            </Button>
                        ) : (
                            <Button type="primary" htmlType="submit">
                                ثبت
                            </Button>
                        )}
                    </div>
                </Form.Item>
            </Form>
        </>
    );
};

export default GeoForm;
